import { CheckoutPaymentInformationSerializer } from "web/types/serializers";

export interface PaymentInformation {
    paymentFormLast4: string | null;
    paymentFormCardType: PaymentCardProvider | null;
}

export const STRIPE_CARD_BRAND_MAP = {
    "american express": "amex",
    "diners club": "diners_club",
    discover: "discover",
    jcb: "jcb",
    mastercard: "mastercard",
    unionpay: "unionpay",
    visa: "visa",
    unknown: "",
} as const;

// Human readable
export type StripePaymentCardProvider = keyof typeof STRIPE_CARD_BRAND_MAP;

// Not perfect, but should hopefully highlight where type is used on FE but not understood on BE
export type PaymentCardProvider = (typeof STRIPE_CARD_BRAND_MAP)[StripePaymentCardProvider] &
    NonNullable<CheckoutPaymentInformationSerializer["card_provider"]>;
